import { CalendarArrowLeftIcon } from './CalendarArrowLeftIcon';

/**
 * author: Terren
 * id 9FB11BA5-47F5-40B8-9BD2-259FEA4E0A6E
 * name calendar-arrow-left
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-arrow-left.svg
 * tags
 * - Date / Time 
 */
export const RescheduleIcon = CalendarArrowLeftIcon;
export default RescheduleIcon